import React from 'react';
import './header.scss';

function AppHeader() {
    return (
        <div className='app-header-wrapper align-center'>
            <h1 className='app-header-title'>URL Shortener</h1>
        </div>
    );
}

export default AppHeader;
